import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        {/* Animated Mandala SVG */}
        <svg className="mandala-background" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <radialGradient id="goldGlow" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#e8c878" stopOpacity="0.6" />
              <stop offset="50%" stopColor="#d4af37" stopOpacity="0.3" />
              <stop offset="100%" stopColor="#d4af37" stopOpacity="0" />
            </radialGradient>
          </defs>
          
          {/* Center glow */}
          <circle cx="400" cy="400" r="180" fill="url(#goldGlow)" className="center-glow" />
          
          {/* Outer circles */}
          <g className="mandala-layer-1">
            <circle cx="400" cy="400" r="280" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.4" />
            <circle cx="400" cy="400" r="240" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.5" />
            <circle cx="400" cy="400" r="200" fill="none" stroke="#d4af37" strokeWidth="1.5" opacity="0.6" />
          </g>
          
          {/* Geometric petals */}
          <g className="mandala-layer-2">
            {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
              <g key={i} transform={`rotate(${angle} 400 400)`}>
                <path
                  d="M 400 200 Q 450 250 400 300 Q 350 250 400 200 Z"
                  fill="none"
                  stroke="#d4af37"
                  strokeWidth="1.5"
                  opacity="0.5"
                />
              </g>
            ))}
          </g>
          
          {/* Inner geometric pattern */}
          <g className="mandala-layer-3">
            {[0, 60, 120, 180, 240, 300].map((angle, i) => (
              <g key={i} transform={`rotate(${angle} 400 400)`}>
                <line
                  x1="400"
                  y1="340"
                  x2="400"
                  y2="460"
                  stroke="#d4af37"
                  strokeWidth="1"
                  opacity="0.4"
                />
              </g>
            ))}
          </g>
          
          {/* Center diamond */}
          <g className="mandala-center">
            <path
              d="M 400 360 L 440 400 L 400 440 L 360 400 Z"
              fill="none"
              stroke="#d4af37"
              strokeWidth="2"
              opacity="0.8"
            />
          </g>
        </svg>
      </div>

      <div className="hero-content">
        <h1 className="hero-title hero-large">
          Tara Ventures
        </h1>
        <p className="hero-subtitle hero-medium">
          Research. Design. Build.
        </p>
        <p className="hero-description body-large">
          Exploring Neural Interfaces, Cultural Systems, and Renewable Energy— engineered to scale over 20 years.
        </p>
        <button className="btn-primary" onClick={scrollToProjects}>
          Explore Our Work
        </button>
      </div>
    </section>
  );
};

export default HeroSection;